import React from "react";
import { styled, Box } from "@mui/system";
import { colors, fontFamilies } from "~/theme";
import { WalletLink } from "~/features/wallet/WalletLink";
import { shortenWallet } from "~/features/formatters";
import { TokenDataSchema } from "~/api/ERC721v4/TokenDataJSONSchema";
import { getAllBlockChainNameByChainId } from "~/api/blockchain/getAllBlockChainNameByChainId";

export type Props = {
    tokenData: TokenDataSchema;
};

const ArtworkDetailsContainer = styled(Box)(({ theme }) => ({
    paddingBottom: theme.spacing(),
    display: "grid",
    gridTemplateColumns: "auto 1fr",
    rowGap: theme.spacing(2.5),
    columnGap: theme.spacing(2),
}));

const ArtworkDetailRow = ({ title, value }) => {
    if (!value) {
        return null;
    }
    return (
        <>
            <Box
                fontFamily={fontFamilies.poppins}
                fontWeight={300}
                lineHeight="20px"
                letterSpacing="0.1px"
                color={colors.black}
                data-testid="row-title"
                sx={(theme) => ({
                    fontSize: "16px",
                    [theme.breakpoints.down(768)]: {
                        fontSize: "13px",
                    },
                })}
            >
                {title}
            </Box>
            <Box
                fontFamily={fontFamilies.poppins}
                fontWeight={400}
                lineHeight="20px"
                letterSpacing="0.1px"
                color={colors.black}
                marginLeft="48px"
                data-testid="row-value"
                sx={(theme) => ({
                    fontSize: "16px",
                    [theme.breakpoints.down(768)]: {
                        fontSize: "13px",
                    },
                })}
            >
                {value}
            </Box>
        </>
    );
};

export const ArtworkDetails: React.FC<Props> = ({ tokenData }) => {
    return (
        <Box>
            <ArtworkDetailsContainer>
                <ArtworkDetailRow
                    title="Medium"
                    value={tokenData?.metadata?.properties?.medium}
                    data-testid="medium-row"
                />
                <ArtworkDetailRow
                    title="Token ID"
                    value={tokenData.tokenId}
                    data-testid="token-id-row"
                />
                <ArtworkDetailRow
                    title="Blockchain"
                    value={getAllBlockChainNameByChainId(
                        tokenData.blockchainId,
                    )}
                    data-testid="blockchain-row"
                />
                <ArtworkDetailRow
                    title="Contract address"
                    data-testid="contact-address-row"
                    value={
                        <WalletLink
                            data-testid="contact-address-row-wallet-link"
                            address={tokenData.tokenAddress as string}
                            networkId={tokenData?.blockchainId}
                        >
                            <Box
                                sx={{
                                    textDecoration: "underline",
                                    color: colors.linkPink,
                                }}
                            >
                                {shortenWallet(
                                    tokenData?.tokenAddress as string,
                                )}
                            </Box>
                        </WalletLink>
                    }
                />
            </ArtworkDetailsContainer>
        </Box>
    );
};
